import React, { useState, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Tooltip } from '@material-ui/core';
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import UseFetchData from "../../../hooks/UseFetchData";
import AddNew from "./AddNew";
//import CreateCountry from "./CreateCountry";
// import CreateState from "./CreateTravellingPolicy";
//import CreateCurrency from "./CreateCurrency";
import CreateEmailTemp from "./CreateEmailTemp";
import CreateCompany from "./CreateCompany";
import CreateBank from "./CreateBank";
import CreateBranch from "./CreateBranch";
import CreateProductType from "./CreateProductType";
import CreateProductCategory from "./CreateProductCategory";
import CreateProductGroup from "./CreateProductGroup";
import CreateReasonMaster from "./CreateReasonMaster";
import CreateUserMaster from "./CreateUserMaster";
import CreateHelpDesk from "./CreateHelpDesk";
import CreateExistingSolution from "./CreateExistingSolution";
import CreateRegionSolution from "./CreateRegionSolution";
//import CreateServiceCentre from "./CreateServiceCentre";
import CreateProductMaster from "./CreateProductMaster";
import CreateSparesMaster from "./CreateSparesMaster";
import CreateStatesMaster from "./CreateStatesMaster";
import CreateCityMaster from "./CreateCityMaster";
import CreateQuestionnaireMaster from "./CreateQuestionnaireMaster";
import TreeView from "./TreeView";
import CreateSupplierMaster from "./CreateSupplierMaster";
import CreateSymptomMaster from "./CreateSymptomMaster";
import CreateCategory from "./CreateCategory";
import CreateHotelStarRating from "./CreateHotelStarRating";
import CreateModeOfTravel from './CreateModeOfTravel';
import CreateExpenseType from './CreateExpenseType';
import CreateTravellingPolicy from "./CreateTravellingPolicy"
import CreateHotelStayPolicy from "./CreateHotelStayPolicy";
import CreateDAPolicy from "./CreateDAPolicy";
import CreateCurrency from "./CreateCurrency";

let MaxWidth = 'xs';

const PrimaryMaster = () => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [Name, setName] = useState('Category');
  const [TypeName, setTypeName] = useState('');
  //const [MaxWidth,setMaxWidth] = useState('xs'); 
  const [PKID, setPKID] = useState('');
  const [Count, setCount] = useState();
  const [isOpen, setOpen] = useState(false);
  const [response, fetchData] = UseFetchData();

  const handleOpenModal = () => {
    setPKID('');
    setOpen(true);
  }

  const openModal = (row) => {
    setPKID(row);
    setOpen(true);
  }

  const PopulateData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("Type", Name);
    bodyFormData.append("SearchString", TypeName);
    fetchData("Primary/List", bodyFormData);
  }

  useEffect(() => {
    debugger;
    if (response.length === 0) {
      setRows([]);
      setCount(0);
    }
    if (response.length > 0) {
      setRows(response);
      setCount(response.length);
    }
  }, [response])

  const returnModal = () => {
    if (Name === "Company") {
      MaxWidth = 'xs';
      return (
        <CreateCompany Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    // else if (Name === "Branch Master") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateBranch Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )

    // }
    // else if (Name === "Product type") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateProductType Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )

    // }
    // else if (Name === "Product Category") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateProductCategory Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )

    // }
    else if (Name === "Category") {
      MaxWidth = 'xs';
      return (
        <CreateCategory Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    else if (Name === "Mode Of Travel") {
      MaxWidth = 'xs';
      return (
        <CreateModeOfTravel Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    else if (Name === "Hotel Star Rating") {
      MaxWidth = 'xs';
      return (
        <CreateHotelStarRating Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    else if (Name === "Currency") {
      MaxWidth = 'xs';
      return (
        <CreateCurrency Name = {Name} setOpen = {setOpen} PopulateData = {PopulateData} PKID = {PKID} />
      )
    }
    else if (Name === "Expense Type") {
      MaxWidth = 'xs';
      return (
        <CreateExpenseType Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
    else if (Name === "Travelling Policy") {
      MaxWidth = 'xs';
      return (
        <CreateTravellingPolicy Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )

    }
    else if (Name === "Hotel Stay Policy") {
      MaxWidth = 'xs';
      return (
        <CreateHotelStayPolicy Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )

    }
    else if (Name === "DA Policy") {
      MaxWidth = 'xs';
      return (
        <CreateDAPolicy Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )

    }
    // else if (Name === "Help Desk") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateHelpDesk Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )

    // }
    // else if(Name === "State"){
    //   MaxWidth = 'xs';
    //   return(
    //     <CreateState Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    // else if (Name === "Currency") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateCurrency Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    // else if (Name === "EmailTemplate") {
    //   MaxWidth = 'md';
    //   return (
    //     <CreateEmailTemp Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }

    // else if (Name === "BankMaster") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateBank Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    // else if (Name === "ExistingSolution") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateExistingSolution Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    // else if (Name === "RegionSolution") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateRegionSolution Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    // else if(Name === "Service Centre"){
    //   MaxWidth = 'md';
    //   return(
    //     <CreateServiceCentre Name = {Name} setOpen = {setOpen} PopulateData={PopulateData}  PKID={PKID} />
    //   )
    // }
    // else if (Name === "Product Master") {
    //   MaxWidth = 'md';
    //   return (
    //     <CreateProductMaster Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    // else if (Name === "Spares Master") {
    //   MaxWidth = 'md';
    //   return (
    //     <CreateSparesMaster Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    // else if (Name === "States Master") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateStatesMaster Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    // else if (Name === "City/Area Master") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateCityMaster Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    // else if (Name === "Questionnaire Master") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateQuestionnaireMaster Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    // else if (Name === "Supplier Master") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateSupplierMaster Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    // else if (Name === "Symptom Master") {
    //   MaxWidth = 'xs';
    //   return (
    //     <CreateSymptomMaster Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
    //   )
    // }
    else {
      MaxWidth = 'xs';
      return (
        <AddNew Name={Name} setOpen={setOpen} PopulateData={PopulateData} PKID={PKID} />
      )
    }
  }

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params.id); }} >Edit</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 70,
      },
      // {
      //   field: Name,
      //   headerName: Name + " Name",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 250,
      // },
    ];
    const copygridclm = gridCols.slice();
    if (Name === "States Master") {
      const clm = {
        field: "State",
        headerName: "State",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      }
      const clm2 = {
        field: "Zone",
        headerName: "Zone",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm3 = {
        field: "IOSCode",
        headerName: "IOS Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      copygridclm.push(clm);
      copygridclm.push(clm2);
      copygridclm.push(clm3);

    }
    // else if (Name === "City/Area Master") {
    //   const clm = {
    //     field: "City",
    //     headerName: "City",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   }
    //   const clm2 = {
    //     field: "State",
    //     headerName: "State",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   copygridclm.push(clm);
    //   copygridclm.push(clm2);

    // }
    // else if (Name === "State") {
    //   const clm = {
    //     field: "StateCode",
    //     headerName: "State Code",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm2 = {
    //     field: "Country",
    //     headerName: "Country",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   copygridclm.push(clm);
    //   copygridclm.push(clm2);
    // }
    // else if (Name === "Symptom Master") {
    //   const clm = {
    //     field: "Symptom",
    //     headerName: "Symptom",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm2 = {
    //     field: "IsActive",
    //     headerName: "IsActive",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   copygridclm.push(clm);
    //   copygridclm.push(clm2);
    // }
    // else if (Name === "Spares Master") {
    //   const clm = {
    //     field: "id",
    //     headerName: ".",
    //     renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params.id); }} >Edit</a> </strong>),
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm2 = {
    //     field: "HSNCODE",
    //     headerName: "HSN CODE",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm3 = {
    //     field: "SpareCode",
    //     headerName: "SpareCode",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm4 = {
    //     field: "SpareName",
    //     headerName: "Spare Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm5 = {
    //     field: "Specifications",
    //     headerName: "Specifications",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm6 = {
    //     field: "TransferRate",
    //     headerName: "Transfer Rate",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm7 = {
    //     field: "ASCRate",
    //     headerName: "ASC Rate",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm8 = {
    //     field: "MRP",
    //     headerName: "MRP",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm9 = {
    //     field: "GSTRate",
    //     headerName: "GST Rate",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm10 = {
    //     field: "image",
    //     headerName: ".",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };

    //   copygridclm.push(clm);
    //   copygridclm.push(clm2);
    //   copygridclm.push(clm3);
    //   copygridclm.push(clm4);
    //   copygridclm.push(clm5);
    //   copygridclm.push(clm6);
    //   copygridclm.push(clm7);
    //   copygridclm.push(clm8);
    //   copygridclm.push(clm9);
    //   copygridclm.push(clm10);
    // }
    // else if (Name === "Service Centre") {
    //   const clm = {
    //     field: "id",
    //     headerName: ".",
    //     renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params.id); }} >Edit</a> </strong>),
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm2 = {
    //     field: "ASCCode",
    //     headerName: "ASCCode",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm3 = {
    //     field: "ServiceCentreName",
    //     headerName: "Service Centre Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm4 = {
    //     field: "BranchName",
    //     headerName: "Branch Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm5 = {
    //     field: "ASI",
    //     headerName: "ASI",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm6 = {
    //     field: "ServiceArea",
    //     headerName: "Service Area",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm7 = {
    //     field: "Address1",
    //     headerName: "Address1",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm8 = {
    //     field: "Address2",
    //     headerName: "Address2",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm9 = {
    //     field: "State",
    //     headerName: "State",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm10 = {
    //     field: "City",
    //     headerName: "City",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm11 = {
    //     field: "Ph1",
    //     headerName: "Ph1",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm12 = {
    //     field: "Ph2",
    //     headerName: "Ph2",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm13 = {
    //     field: "Ph3",
    //     headerName: "Ph3",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm14 = {
    //     field: "Ph4",
    //     headerName: "Ph4",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm15 = {
    //     field: "Email",
    //     headerName: "Email",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   }; const clm16 = {
    //     field: "Owner",
    //     headerName: "Owner",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   }; const clm17 = {
    //     field: "OwnerPh",
    //     headerName: "OwnerPh",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   }; const clm18 = {
    //     field: "SupervisourPh",
    //     headerName: "SupervisourPh",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   }; const clm19 = {
    //     field: "Exec1",
    //     headerName: "Exec1",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm20 = {
    //     field: "Exec2",
    //     headerName: "Exec2",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm21 = {
    //     field: "FSCMontly",
    //     headerName: "FSC Montly",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm22 = {
    //     field: "FSCCalls",
    //     headerName: "FSC Calls",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm23 = {
    //     field: "CallChargesLocal",
    //     headerName: "Call Charges Local",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm24 = {
    //     field: "LocalAreaLimitInKM",
    //     headerName: "Local Area Limit In KM",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm25 = {
    //     field: "CallChargesOS",
    //     headerName: "Call Charges OS",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm26 = {
    //     field: "ConveyencePerKM",
    //     headerName: "Conveyence Per KM",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };

    //   copygridclm.push(clm);
    //   copygridclm.push(clm2);
    //   copygridclm.push(clm3);
    //   copygridclm.push(clm4);
    //   copygridclm.push(clm5);
    //   copygridclm.push(clm6);
    //   copygridclm.push(clm7);
    //   copygridclm.push(clm8);
    //   copygridclm.push(clm9);
    //   copygridclm.push(clm10);
    //   copygridclm.push(clm11);
    //   copygridclm.push(clm12);
    //   copygridclm.push(clm13);
    //   copygridclm.push(clm14);
    //   copygridclm.push(clm15);
    //   copygridclm.push(clm16);
    //   copygridclm.push(clm17);
    //   copygridclm.push(clm18);
    //   copygridclm.push(clm19);
    //   copygridclm.push(clm20);
    //   copygridclm.push(clm21);
    //   copygridclm.push(clm22);
    //   copygridclm.push(clm23);
    //   copygridclm.push(clm24);
    //   copygridclm.push(clm25);
    //   copygridclm.push(clm26);

    // }
    // else if (Name === "EmailTemplate") {
    //   const clm = {
    //     field: "Subject",
    //     headerName: "Subject",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   }
    //   const clm2 = {
    //     field: "EmailBody",
    //     headerName: "Email Body",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 250,
    //     renderCell: (params) => (
    //       <Tooltip title={params.row.EmailBody} >
    //         <span className="table-cell-trucate">{params.row.EmailBody}</span>
    //       </Tooltip>
    //     ),
    //   }
    //   copygridclm.push(clm);
    //   copygridclm.push(clm2);
    // }
    // else if (Name === "Product Master") {

    //   const clm1 = {
    //     field: "Category",
    //     headerName: "Category",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm2 = {
    //     field: "ProductName",
    //     headerName: "Product Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm3 = {
    //     field: "ItemCode",
    //     headerName: "ItemCode",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm4 = {
    //     field: "ModelCode",
    //     headerName: "Model Code",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm5 = {
    //     field: "GroupName",
    //     headerName: "Group Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm6 = {
    //     field: "Specification",
    //     headerName: "Specification",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm7 = {
    //     field: "WarrantyPeriod",
    //     headerName: "Warranty Period",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   copygridclm.push(clm1);
    //   copygridclm.push(clm2);
    //   copygridclm.push(clm3);
    //   copygridclm.push(clm4);
    //   copygridclm.push(clm5);
    //   copygridclm.push(clm6);
    //   copygridclm.push(clm7);

    // }
    // else if (Name === "Questionnaire Master") {

    //   const clm1 = {
    //     field: "ProductCategoryName",
    //     headerName: "Product Category Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm2 = {
    //     field: "Seq",
    //     headerName: "Seq",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm3 = {
    //     field: "Question",
    //     headerName: "Question",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm4 = {
    //     field: "PossibleOptionsArea",
    //     headerName: "Possible Options Area",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };

    //   copygridclm.push(clm1);
    //   copygridclm.push(clm2);
    //   copygridclm.push(clm3);
    //   copygridclm.push(clm4);

    // }
    // else if (Name === "BankMaster") {
    //   const clm1 = {
    //     field: "AccountNo",
    //     headerName: "BankAccount Number",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm2 = {
    //     field: "NameOfBankAcccount",
    //     headerName: "NameOfBank Acccount",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm3 = {
    //     field: "Address",
    //     headerName: "Address",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm4 = {
    //     field: "CurrencyID",
    //     headerName: "ACCOUNT CURRENCY",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm5 = {
    //     field: "BICCODE",
    //     headerName: "BIC CODE",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm6 = {
    //     field: "IntermediaryBankName",
    //     headerName: "INTERMEDIARY BANK NAME",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm7 = {
    //     field: "SwiftCode",
    //     headerName: "SWIFT CODE",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm8 = {
    //     field: "IntermediaryBankAddress",
    //     headerName: "BANK PHYSICAL ADDRESS",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   copygridclm.push(clm1);
    //   copygridclm.push(clm2);
    //   copygridclm.push(clm3);
    //   copygridclm.push(clm4);
    //   copygridclm.push(clm5);
    //   copygridclm.push(clm6);
    //   copygridclm.push(clm7);
    //   copygridclm.push(clm8);

    // }
    // else if (Name === "ExistingSolution") {
    //   const clm1 = {
    //     field: "ExistingSolutionType",
    //     headerName: "ExistingSolutionType",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 240,
    //   };
    //   const clm2 = {
    //     field: "ExistingSolution",
    //     headerName: "ExistingSolution",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   copygridclm.push(clm1);
    //   copygridclm.push(clm2);
    // }
    // else if (Name === "RegionSolution") {
    //   const clm1 = {
    //     field: "ReasonCode",
    //     headerName: "RegionCode",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   copygridclm.push(clm1);
    //   //copygridclm.push(clm2);
    // }
    // else if (Name === "ServiceCentre") {
    //   const clm1 = {
    //     field: "ServiceCentre",
    //     headerName: "ServiceCentre",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   copygridclm.push(clm1);
    //   //copygridclm.push(clm2);
    // }
    // else if (Name === "Branch Master") {
    //   const clm = {
    //     field: "BranchType",
    //     headerName: "Branch Type",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm1 = {
    //     field: "BranchCode",
    //     headerName: "Branch Code",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm2 = {
    //     field: "BranchName",
    //     headerName: "Branch Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm3 = {
    //     field: "State",
    //     headerName: "State",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm4 = {
    //     field: "Address1",
    //     headerName: "Address1",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm5 = {
    //     field: "Address2",
    //     headerName: "Address2",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm6 = {
    //     field: "Address3",
    //     headerName: "Address3",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm7 = {
    //     field: "Ph1",
    //     headerName: "Ph1",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm8 = {
    //     field: "Ph2",
    //     headerName: "Ph2",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm9 = {
    //     field: "Ph3",
    //     headerName: "Ph3",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm10 = {
    //     field: "Ph4",
    //     headerName: "Ph4",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm11 = {
    //     field: "FaxNo",
    //     headerName: "FaxNo",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm12 = {
    //     field: "Email",
    //     headerName: "Email",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm13 = {
    //     field: "CanGoodsReceive",
    //     headerName: "CanGoodsReceive",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 230,
    //   };
    //   copygridclm.push(clm);
    //   copygridclm.push(clm1);
    //   copygridclm.push(clm2);
    //   copygridclm.push(clm3);
    //   copygridclm.push(clm4);
    //   copygridclm.push(clm5);
    //   copygridclm.push(clm6);
    //   copygridclm.push(clm7);
    //   copygridclm.push(clm8);
    //   copygridclm.push(clm9);
    //   copygridclm.push(clm10);
    //   copygridclm.push(clm11);
    //   copygridclm.push(clm12);
    //   copygridclm.push(clm13);

    // }
    // else if (Name === "Product type") {
    //   const clm = {
    //     field: "ProductTypeName",
    //     headerName: "Product Type Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 250,
    //   };
    //   const clm1 = {
    //     field: "ProductTypeCode",
    //     headerName: "Product Type Code",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 250,
    //   };
    //   copygridclm.push(clm);
    //   copygridclm.push(clm1);

    // }
    // else if (Name === "Product Category") {
    //   const clm = {
    //     field: "ProductCategoryName",
    //     headerName: "Product Category Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 250,
    //   };

    //   copygridclm.push(clm);

    // }
    // else if (Name === "Product Group") {
    //   const clm = {
    //     field: "ProductServiceChargeGroupName",
    //     headerName: "ProductServiceChargeGroupName",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 300,
    //   };

    //   copygridclm.push(clm);

    // }
    // else if (Name === "Reason Master") {
    //   const clm = {
    //     field: "Reason",
    //     headerName: "Reason",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 150,
    //   };
    //   const clm1 = {
    //     field: "ReasonType",
    //     headerName: "ReasonType",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm2 = {
    //     field: "IsActive",
    //     headerName: "IsActive",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 150,
    //   };

    //   copygridclm.push(clm);
    //   copygridclm.push(clm1);
    //   copygridclm.push(clm2);

    // }

    // else if (Name === "User Master") {
    //   const clm = {
    //     field: "UserName",
    //     headerName: "User Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };

    //   const clm1 = {
    //     field: "EmployeeName",
    //     headerName: "Employee Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 230,
    //   };
    //   const clm2 = {
    //     field: "BranchName",
    //     headerName: "Branch Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm3 = {
    //     field: "Designation",
    //     headerName: "Designation",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm4 = {
    //     field: "UserRole",
    //     headerName: "User Role",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm5 = {
    //     field: "MobileNo",
    //     headerName: "Mobile No",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 150,
    //   };
    //   const clm6 = {
    //     field: "PhoneNo",
    //     headerName: "Phone No",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm7 = {
    //     field: "EmailID",
    //     headerName: "EmailID",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 150,
    //   };
    //   const clm8 = {
    //     field: "Address",
    //     headerName: "Address",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 150,
    //   };
    //   const clm9 = {
    //     field: "ReportingTo",
    //     headerName: "Reporting To",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm10 = {
    //     field: "IsActive",
    //     headerName: "IsActive",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 150,
    //   };

    //   copygridclm.push(clm);
    //   copygridclm.push(clm1);
    //   copygridclm.push(clm2);
    //   copygridclm.push(clm3);
    //   copygridclm.push(clm4);
    //   copygridclm.push(clm5);
    //   copygridclm.push(clm6);
    //   copygridclm.push(clm7);
    //   copygridclm.push(clm8);
    //   copygridclm.push(clm9);
    //   copygridclm.push(clm10);

    // }

    // else if (Name === "Service Charge") {
    //   const clm = {
    //     field: "ServiceCentreName",
    //     headerName: "Service Centre Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 230,
    //   };
    //   const clm1 = {
    //     field: "AllSmallProducts",
    //     headerName: "All Small Products",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 230,
    //   };
    //   const clm2 = {
    //     field: "FoodProcessor",
    //     headerName: "Food Processor",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm3 = {
    //     field: "Mixer&Juicer",
    //     headerName: "Mixer & Juicer",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 200,
    //   };
    //   const clm4 = {
    //     field: "OTG",
    //     headerName: "OTG",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 150,
    //   };

    //   copygridclm.push(clm);
    //   copygridclm.push(clm1);
    //   copygridclm.push(clm2);
    //   copygridclm.push(clm3);
    //   copygridclm.push(clm4);

    // }

    // else if (Name === "Supplier Master") {
    //   const clm = {
    //     field: "SupplierMasterName",
    //     headerName: "Supplier Master Name",
    //     headerClassName: "super-app-theme--header",
    //     headerAlign: "center",
    //     width: 230,
    //   };
    //   copygridclm.push(clm);
    // }
    else if (Name === "Category") {
      const clm = {
        field: "Category",
        headerName: "Category Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 230,
      };

      copygridclm.push(clm);

    }

    else if (Name === "Mode Of Travel") {
      const clm = {
        field: "ModeOfTravelType",
        headerName: "Travel Type",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm1 = {
        field: "ModeOfTravel",
        headerName: "Mode Of Travel",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };

      copygridclm.push(clm);
      copygridclm.push(clm1);

    }
    else if (Name === "Hotel Star Rating") {
      const clm = {
        field: "HotelStarRating",
        headerName: "Hotel Star Rating",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 230,
      };
      copygridclm.push(clm);
    }
    else if (Name === "Expense Type") {
      const clm = {
        field: "ExpenseType",
        headerName: "Expense Type",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 230,
      };
      copygridclm.push(clm);
    }

    else if (Name === "Currency") {
      const clm = {
        field: "Currency",
        headerName: "Currency",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 230,
      };
      const clm1 = {
        field: "ConvFactor",
        headerName: "Conv Factor",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 230,
      };

      copygridclm.push(clm);
      copygridclm.push(clm1);

    }

    else if (Name === "Travelling Policy") {
      // const clm = {
      //   field: "id",
      //   headerName: ".",
      //   renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params.id); }} >Edit</a> </strong>),
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 50,
      // };
      // const clm = {
      //   field: "TravellingPolicyType",
      //   headerName: "Travelling Policy Type",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // };
      const clm = {
        field: "Category",
        headerName: "Category",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm1 = {
        field: "TravellingPolicyType",
        headerName: "Travelling Policy Type",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm2 = {
        field: "ModeOfTravel",
        headerName: "Mode Of Travel",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm3 = {
        field: "UpperCeilingCapitalCities",
        headerName: "Upper Ceiling Capital Cities",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm4 = {
        field: "UpperCeilingNonCapitalCities",
        headerName: "Upper Ceiling Non Capital Cities",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };


      copygridclm.push(clm);
      copygridclm.push(clm1);
      copygridclm.push(clm2);
      copygridclm.push(clm3);
      copygridclm.push(clm4);

    }
    else if (Name === "Hotel Stay Policy") {
      // const clm = {
      //   field: "id",
      //   headerName: ".",
      //   renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params.id); }} >Edit</a> </strong>),
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 50,
      // };
      // const clm = {
      //   field: "HotelStarRating",
      //   headerName: "Hotel Star Rating",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // };
      const clm = {
        field: "Category",
        headerName: "Category",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm1 = {
        field: "HotelStarRating",
        headerName: "Hotel Star Rating",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm2 = {
        field: "UpperCeilingCapitalCities",
        headerName: "Upper Ceiling Capital Cities",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm3 = {
        field: "UpperCeilingNonCapitalCities",
        headerName: "Upper Ceiling Non Capital Cities",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      // const clm6 = {
      //   field: "ASCRate",
      //   headerName: "ASC Rate",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 200,
      // };

      copygridclm.push(clm);
      copygridclm.push(clm1);
      copygridclm.push(clm2);
      copygridclm.push(clm3);
      //copygridclm.push(clm);
      // copygridclm.push(clm6);
    }
    else if (Name === "DA Policy") {
      // const clm = {
      //   field: "id",
      //   headerName: ".",
      //   renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params.id); }} >Edit</a> </strong>),
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 50,
      // };
      const clm = {
        field: "Category",
        headerName: "Category",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm1 = {
        field: "DACapitalCities",
        headerName: "DA Capital Cities",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm2 = {
        field: "DANonCapitalCities",
        headerName: "DA Non Capital Cities",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };
      const clm3 = {
        field: "DAOwnArrangement",
        headerName: "DA Own Arrangement",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
      };

      copygridclm.push(clm);
      copygridclm.push(clm1);
      copygridclm.push(clm2);
      copygridclm.push(clm3);

    }


    setColumns(copygridclm);
    PopulateData()
  }, [Name]);

  return (
    <div>
      <table style={{ width: "100%", marginTop: "1%" }}>
        <tbody>
          <tr>
            <td style={{ width: "13%", border: "0.1rem solid gray", verticalAlign: 'top' }}>
              <TreeView setName={setName} />
            </td>
            <td>
              <table style={{ width: "100%", marginTop: -9 }}>
                <tbody>
                  <tr>
                    <td>
                      <h1>{Name}</h1>
                    </td>
                  </tr>

                  <tr>
                    <BiztranControls.Input
                      label={Name + " Name"}
                      id={Name}
                      onChange={(e) => setTypeName(e.target.value)}
                    />
                    <BiztranControls.Button
                      text="SEARCH"
                      startIcon={<SearchIcon />}
                      onClick={() => {
                        PopulateData();
                      }}
                    />
                    <label style={{ fontWeight: 'bold', width: 10 }}>{Count}</label>
                    <BiztranControls.Button
                      text="ADD NEW"
                      startIcon={<AddCircleOutlineIcon />}
                      onClick={() => {
                        handleOpenModal();
                      }}
                    />
                    <label style={{ fontWeight: 'bold', width: 10 }}></label>
                    {/* <BiztranControls.Button
                      text="EXPORT TO EXCEL"
                      startIcon={<AddCircleOutlineIcon />}
                      style={{ width: "18%" }}
                      // onClick={() => {
                      //   handleOpenModal();
                      // }}
                    /> */}
                    <ModalFrame
                      title={Name}
                      maxWidth={MaxWidth}
                      isOpen={isOpen}
                      setOpen={setOpen}
                    >
                      {returnModal()}
                    </ModalFrame>
                  </tr>
                  <tr>
                    <td>
                      <BiztranControls.DataGrid
                        rowHeight={25}
                        headerHeight={34}
                        // header
                        rows={rows}
                        columns={columns}
                        checkboxSelection={false}
                        hideFooterPagination={true}
                        hideFooter={true}
                        Height="700px"
                        Width="100%"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PrimaryMaster;
